export default __webpack_public_path__ + "static/media/bottle_rio.57e3bb73.png";